import { pubSub } from './pubSub-sidecar'
import { storer } from '../lib/storer-sidecar'

export interface ISettings {
  devMode: boolean
  muteSound: boolean
  muteMusic: boolean
  skipStart: boolean
  // Extended
  filename: string
  testRigNum: number
}

let settings: ISettings = {
  devMode: false,
  muteSound: false,
  muteMusic: false,
  skipStart: false,
  filename: 'test',
  testRigNum: 0,
}

let _localStorageKey = ''
let _version = 0
export function create(localStorageKey: string, version: number) {
  _localStorageKey = localStorageKey
  _version = version
  load()
}

export function get() {
  return settings
}
export function update(updates: Partial<ISettings>, doSave = true) {
  settings = Object.assign({}, settings, updates)
  if (doSave) {
    save()
  }
  pubSub.emit('settings:update')
}

function load() {
  let data = storer.load(_localStorageKey, _version)
  if (data) {
    update(data, false)
  }
  console.log('loaded settings', data)
}

function save() {
  storer.save(_localStorageKey, _version, get())
}
